import Vue from 'vue'

import VueCookies from 'vue-cookies'

const host = window.location.host || ''

// console.log(VueCookies, 'VueCookies before ')

import {
  storeGet,
  storeSet,
  storeRm
} from '@/tools/hukeStore'

// 重写 VueCookies  get、set、remove 方法

const originCookiesSet = VueCookies.set

const originCookiesRm = VueCookies.remove

const originCookiesGet = VueCookies.get

const originCookiesIsKey = VueCookies.isKey

VueCookies.set = (...args) => {
  const [
    keyName,
    val
  ] = args || []

  const key2hukekey = {
    'token': 'huke_token',
    'orgid': 'huke_org_id',
    'roles': 'huke_roles',
    'org': 'huke_org',
    'profileid': 'huke_profile_id'
  }

  const hasHukeKey = key2hukekey[keyName]

  // console.log(defaultVal, 'defaultVal VueCookies.get')

  // console.log(val, 'val VueCookies.set')

  // console.log(keyName, 'keyName VueCookies.set', hasHukeKey, 'hasHukeKey')

  originCookiesSet.apply(VueCookies, args)

  if (hasHukeKey) {
    storeSet(hasHukeKey, val)
  }
}

VueCookies.remove = (...args) => {
  const [
    keyName
  ] = args || []

  const key2hukekey = {
    'token': 'huke_token',
    'orgid': 'huke_org_id',
    'roles': 'huke_roles',
    'org': 'huke_org',
    'profileid': 'huke_profile_id'
  }

  const hasHukeKey = key2hukekey[keyName]

  originCookiesRm.apply(VueCookies, args)

  if (hasHukeKey) {
    storeRm(hasHukeKey)
  }
}

// console.log(originCookiesGet, 'originCookiesGet')

VueCookies.get = (...args) => {
  const [
    keyName
  ] = args || []

  const key2hukekey = {
    'token': 'huke_token',
    'orgid': 'huke_org_id',
    'roles': 'huke_roles',
    'org': 'huke_org',
    'profileid': 'huke_profile_id'
  }

  const hasHukeKey = key2hukekey[keyName]

  const defaultVal = hasHukeKey ? storeGet(hasHukeKey) : ''

  // console.log(defaultVal, 'defaultVal VueCookies.get', hasHukeKey, 'hasHukeKey')

  // console.log(keyName, 'keyName VueCookies.get')

  return originCookiesGet.apply(VueCookies, args) || defaultVal
}

VueCookies.isKey = (...args) => {
  const [
    keyName
  ] = args || []

  const key2hukekey = {
    'token': 'huke_token',
    'orgid': 'huke_org_id',
    'roles': 'huke_roles',
    'org': 'huke_org',
    'profileid': 'huke_profile_id'
  }

  const hasHukeKey = key2hukekey[keyName]

  const defaultVal = hasHukeKey ? !!storeGet(hasHukeKey) : false

  //

  return originCookiesIsKey.apply(VueCookies, args) || defaultVal
}

// 这个暂时别加，可能存在问题
// if (host.includes('manban')) {
//   const domain = host.startsWith('dev.') ? 'manbanapp.com' : host
//   const defaultOptions = ['1d', '/', , `.${domain}`, 'Lax']

//   VueCookies.config(...defaultOptions)
// }

// console.log(VueCookies, 'VueCookies after')

Vue.use(VueCookies)

// export const manbanCookies = VueCookies

export default VueCookies
